import React, {useState, useEffect} from 'react';
import ic_left from 'image/ic_arrow_left.svg';
import ic_download from 'image/icon/ic_download.svg';
import ic_close from 'image/icon/ic-delete.svg';
import {BtnWithIconAndText} from 'components/btns'
import {BoardDetailComments} from 'components/section';
import {BoardCommentTextarea} from 'components/items';

import firebase from 'library/firebase-config.js';
import 'firebase/firestore';
const db = firebase.firestore();
const COLLECTION = 'customer_qna';

const DetailQna = (props) => {
  const [nowComment, setNowComment] = useState('');
  const [nowId, setNowId] = useState();

  useEffect(()=> {
    setNowId(props.data.id);
  }, [props])

  const handleTextChange = (e) => {
    setNowComment(e.target.value);
  }

  const handleSubmit = async () => {
    const ref = db.collection(COLLECTION).doc(nowId);
    const newComment = {
      text: nowComment,
      timestamp: new Date()
    }
    await ref.update({
      comment: [...props.data.comment,newComment]
    })
    props.updateComment(newComment);
    setNowComment('');
  }

  const handleBackBtnClick = () => {
    props.back(null)
  }

  return (
    <section className={`DetailQna BoardDetailContents ${props.className}`}>
      
      <div className="board-contents">
        <div className="con admin">

          <div className="wrap-btns">
            <div className="btn-back" onClick = {handleBackBtnClick}>
              <img className="ic-back" src={ic_left} alt="icon back"/>
              <p>목록으로</p>
            </div>

            <ul className="btn-delete">
              <img src={ic_close} alt="delete" onClick = {() => {props.handleDeleteClick(props.data.id)}}/>
            </ul>
          </div>
          
          <p className="board-title">{props.data.title}</p>

          
          <p className="board-text">
            {props.data.text 
            ? props.data.text.split('\n').map((line, index) => {
              return <span key= {index}>{line}<br/></span>
            })
            : ''}
          </p>

          <div className="wrap-files">

            {props.data.images
            ? props.data.images.map((el,index) => {
              return <BtnWithIconAndText className="board-file down" download = {true} target = {`_blank`} to = {el.imageUrl} icon = {ic_download} text = {el.imageName} key = {index}/>
            })
            : ""}
            
          </div>

          <ul className="wrap-info">
            <li>
              <p className='info-header'>{`name`}</p>
              <p className='info-body'>{props.data.name}</p>
            </li>
            <li>
              <p className='info-header'>{`email`}</p>
              <p className='info-body'>{props.data.email}</p>
            </li>

            <li>
              <p className='info-header'>{`contact`}</p>
              <p className='info-body'>{props.data.contact}</p>
            </li>
          </ul>

          <BoardDetailComments comment = {props.data.comment} />
          <BoardCommentTextarea  handleTextChange = {handleTextChange} handleSubmit = {handleSubmit} nowComment = {nowComment}/>

        </div>
      </div>


    </section>
  );
}

export default DetailQna;